import { createActions, createState, createReducer } from 'reduxsauce-crud'

const DEEP = { deep: true }

export const CompanyAccountRedux = createActions({
  createPaymentRequest: ['companyId', 'payment'],
  createPaymentSuccess: [''],
  createPaymentError: ['error'],
  deletePaymentRequest: ['companyId', 'payment'],
  deletePaymentSuccess: [''],
  deletePaymentError: ['error'],
}, {
  prefix: 'COMPANY_ACCOUNT_',
  defaultActions: {
    get: true,
  },
})

const { Types, Creators } = CompanyAccountRedux
export const CompanyAccountTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  create: {
    fetching: false,
    error: null,
  },
  delete: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

/* ------------- Reducers ------------- */

const createPaymentRequest = state => state.merge({
  create: {
    fetching: true,
    error: null,
  },
}, DEEP)

const createPaymentSuccess = state =>
  // const newBalance = sortBalanceArray(state, newCharge, true)
  // const balance = R.clone(state.get.results)
  // for (let i = 1; i < newBalance.length; i++) {
  //   balance.transactions.unshift(newBalance[i])
  // }
  state.merge({ create: { fetching: false, error: null } }, DEEP)


const createPaymentError = (state, { error }) =>
  state.merge({ create: { fetching: false, error } }, DEEP)

const deletePaymentRequest = state => state.merge({
  delete: {
    fetching: true,
    error: null,
  },
}, DEEP)

const deletePaymentSuccess = state =>
  // const newBalance = sortBalanceArray(state, newCharge, true)
  // const balance = R.clone(state.get.results)
  // for (let i = 1; i < newBalance.length; i++) {
  //   balance.transactions.unshift(newBalance[i])
  // }
  state.merge({ delete: { fetching: false, error: null } }, DEEP)


const deletePaymentError = (state, { error }) =>
  state.merge({ delete: { fetching: false, error } }, DEEP)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.createPaymentSuccess]: createPaymentSuccess,
  [Types.createPaymentRequest]: createPaymentRequest,
  [Types.createPaymentError]: createPaymentError,
  [Types.deletePaymentSuccess]: deletePaymentSuccess,
  [Types.deletePaymentRequest]: deletePaymentRequest,
  [Types.deletePaymentError]: deletePaymentError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
})



// WEBPACK FOOTER //
// ./src/Data/Redux/CompanyAccountRedux.js